<template>
  <div class="yht-backStage-jpww">
    <div class="yht-backStage-jpww-content">
      <div class="flex mb20" v-if="isShowAction">
        <div
          class="yht-backStage-jpww-content_btn mr15 cp"
          @click="BatchOnOrOff('0')"
        >
          批量下线
        </div>
        <div
          class="yht-backStage-jpww-content_btn cp"
          @click="BatchOnOrOff('1')"
        >
          批量上线
        </div>
      </div>
      <div class="yht-backStage-jpww-content_search">
        <el-input
          class="jpww-input"
          placeholder="文物检索···"
          v-model="keyWord"
          @keyup.enter.native="handleSearch"
        ></el-input>
        <div
          class="yht-backStage-jpww-content_search_icon cp"
          @click="handleSearch"
        ></div>
      </div>
      <div class="yht-backStage-jpww_table">
        <el-table
          v-loading="loading"
          ref="table"
          height="calc(100% - 50px)"
          tooltip-effect="light"
          :row-key="
            (row) => {
              return row.id;
            }
          "
          @selection-change="handleSelectionChange"
          :data="jpwwList"
        >
          <el-table-column label="" width="20" key="1"></el-table-column>
          <el-table-column
            type="selection"
            width="55"
            :reserve-selection="true"
          ></el-table-column>
          <el-table-column label="序号" width="80" type="index" key="3">
            <span slot-scope="scope">{{
              scope.$index + (pageNo - 1) * pageSize + 1
            }}</span>
          </el-table-column>
          <el-table-column prop="totalRegistrationId" label="总登记号" key="4">
            <span slot-scope="scope" :title="scope.row.totalRegistrationId">{{
              scope.row.totalRegistrationId
            }}</span>
          </el-table-column>
          <el-table-column prop="name" label="名称" width="300" key="5">
            <span slot-scope="scope" :title="scope.row.name">{{
              scope.row.name
            }}</span>
          </el-table-column>
          <el-table-column prop="eraStr" label="年代" key="6">
            <span slot-scope="scope" :title="scope.row.eraStr">{{
              scope.row.eraStr
            }}</span>
          </el-table-column>
          <el-table-column
            prop="heritageLevelStr"
            label="级别"
            width="60"
            key="7"
          >
            <span slot-scope="scope" :title="scope.row.heritageLevelStr">{{
              scope.row.heritageLevelStr
            }}</span>
          </el-table-column>
          <el-table-column prop="collectionCategoryStr" label="类别" key="8">
            <span slot-scope="scope" :title="scope.row.collectionCategoryStr">{{
              scope.row.collectionCategoryStr
            }}</span>
          </el-table-column>
          <el-table-column prop="textureCategoryStr" label="质地" key="9">
            <span slot-scope="scope" :title="scope.row.textureCategoryStr">{{
              scope.row.textureCategoryStr
            }}</span>
          </el-table-column>
          <el-table-column prop="realSize" label="尺寸" key="10">
            <span slot-scope="scope" :title="scope.row.realSize">{{
              scope.row.realSize
            }}</span>
          </el-table-column>
          <el-table-column prop="isOnlineStr" label="全部状态" key="11">
            <template slot-scope="scope">
              <span
                class="yht-backStage-jpww_table_status"
                :class="{
                  online: scope.row.isOnlineStr === '线上',
                  offline: scope.row.isOnlineStr === '下线',
                }"
                :title="scope.row.isOnlineStr"
                >{{ scope.row.isOnlineStr }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="操作" key="12" v-if="isShowAction">
            <template slot-scope="scope">
              <div class="yht-backStage-jpww_table_operate">
                <div
                  class="yht-backStage-jpww_table_view cp"
                  :title="'预览'"
                  @click="viewDetail(scope.row)"
                ></div>
                <div
                  class="yht-backStage-jpww_table_line cp"
                  :class="{ offline: scope.row.isOnline === '1' }"
                  :title="scope.row.isOnline === '1' ? '下线' : '上线'"
                  @click="singleOnOffLine(scope.row)"
                ></div>
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <span
              class="mt10"
              style="display: block; font-size: 12px; color: #666666"
              >暂无查询数据</span
            >
          </template>
        </el-table>
        <!-- 页码 -->
        <div class="yht-backStage-jpww_page yht-backStage-page">
          <el-pagination
            v-show="total > 15 && !loading"
            background
            layout="total, prev, pager, next"
            :current-page="pageNo"
            :page-size="pageSize"
            :total="total"
            @current-change="changePage"
          >
          </el-pagination>
        </div>
      </div>
      <!--上下线确认-->
      <div class="yht-backStage_dialog">
        <el-dialog
          :title="checkStatus === '0' ? '下线确认' : '上线确认'"
          width="400px"
          :visible="showBatch"
          :close-on-click-modal="false"
          :before-close="handleBatchCancel"
        >
          <div
            v-show="BatchOrSingle === 'batch'"
            class="te-center mt15 yht-backStage_dialog_content"
          >
            确定<span v-text="checkStatus === '0' ? '下线' : '上线'"></span
            >所选精品文物？
          </div>
          <div v-show="BatchOrSingle === 'single'" class="te-center mt15">
            <div v-text="selectObj.name"></div>
            <div class="mt10">
              将<span v-text="checkStatus === '0' ? '从' : '在'"></span
              >精品文物展示模块<span
                v-text="checkStatus === '0' ? '下线' : '上线'"
              ></span>
            </div>
          </div>
          <div class="yht-backStage_dialog_btnBox mt30">
            <div
              class="yht-backStage_dialog_btn yht-backStage_dialog_btnConfirm"
              @click="handleConfirm"
            >
              确认
            </div>
            <div
              class="yht-backStage_dialog_btn yht-backStage_dialog_btnCancel"
              @click="handleBatchCancel"
            >
              取消
            </div>
          </div>
        </el-dialog>
        <el-dialog
          :title="selectObj.name"
          width="620px"
          :visible="showImg"
          :close-on-click-modal="false"
          :before-close="handleImgCancel"
        >
          <div class="yht-backStage_dialog_imgBox">
            <img
              class="yht-backStage_dialog_img"
              v-if="urlList && urlList.length > 0"
              :src="urlList[pageImgNo - 1].imgUrl"
              alt=""
            />
          </div>
          <div
            class="yht-backStage-dialog_page yht-backStage-page"
            v-show="totalImg > 1 && !loading"
          >
            <el-pagination
              background
              layout="prev, pager, next"
              :current-page="pageImgNo"
              :page-size="pageImgSize"
              :total="totalImg"
              @current-change="changeImgPage"
            >
            </el-pagination>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'jpww',
  data () {
    return {
      loading: false,
      // 搜索框输入内容
      keyWord: '',
      // 精品文物表格list
      jpwwList: [],
      // 搜索参数
      searchText: '',
      // 页数
      pageNo: 1,
      // 条数
      pageSize: 15,
      // 总数
      total: 0,
      // 上线还是下线
      checkStatus: '',
      idList: [],
      // 上下线确认框显示
      showBatch: false,
      // 批量上下线还是单独上下线
      BatchOrSingle: '',
      // 选中的文物
      selectObj: { name: '' },
      // 文物图片弹框显示
      showImg: false,
      // 文物图片list
      urlList: [{ imgUrl: '' }],
      pageImgNo: 1,
      pageImgSize: 1,
      totalImg: 0
    }
  },
  props: {},
  computed: {
    isShowAction () {
      return (
        localStorage.getItem('name') === 'admin' || localStorage.getItem('name') === 'sa'
      )
    }
  },
  mounted () {
    this.getListMHCollect()
  },
  methods: {
    // 获取精品文物列表
    getListMHCollect () {
      const self = this
      self.loading = true
      const data = {
        orderby: '0',
        searchConditions: this.searchText.trim(),
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      axios
        .post('/juanzonggg/collect/ListMHCollect', data)
        .then((json) => {
          if (json.data.code === 200) {
            self.jpwwList = json.data.data.rows
            self.total = json.data.data.totalRows
          } else {
            self.$message.warning(json.data.message)
          }
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => {
          self.loading = false
        })
    },

    // 批量选择
    handleSelectionChange (val) {
      this.idList = val.map((m) => {
        return m.id
      })
    },

    // 检索功能
    handleSearch () {
      this.searchText = this.keyWord
      this.pageNo = 1
      this.getListMHCollect()
    },

    // 点击分页
    changePage (val) {
      this.pageNo = val
      this.getListMHCollect()
    },

    // 点击批量上下线
    BatchOnOrOff (param) {
      if (this.idList.length === 0) {
        this.$message.warning('请先选择要上下线的文物！')
        return
      }
      this.checkStatus = param
      this.BatchOrSingle = 'batch'
      this.showBatch = true
    },

    // 关闭上下线弹窗
    handleBatchCancel () {
      this.idList = []
      this.$refs.table.clearSelection()
      this.showBatch = false
    },

    // 点击单独上下线
    singleOnOffLine (param) {
      this.selectObj = param
      this.idList = [param.id]
      this.checkStatus = param.isOnline === '0' ? '1' : '0'
      this.BatchOrSingle = 'single'
      this.showBatch = true
    },

    // 精品文物上下线
    handleConfirm () {
      const self = this
      const ids = this.idList.join(',')
      const data = {
        checkStatus: this.checkStatus,
        dbcode: 'COLLECT',
        ids: ids
      }
      axios
        .post('/yuhuamenhu/collect/updateIsOnline', data)
        .then((json) => {
          if (json.data.code === 200) {
            this.handleBatchCancel()
            this.getListMHCollect()
            self.$message.success(json.data.data)
          } else {
            self.$message.warning(json.data.errorMessage)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },

    // 查看详情
    viewDetail (param) {
      const self = this
      self.selectObj = param
      axios
        .get('/yuhuamenhu/collect/getImageListByCollectIdMH', {
          params: {
            id: param.id
          }
        })
        .then((json) => {
          if (json.data.code === 200) {
            json.data.data.forEach((item) => {
              item.imgUrl = window.location.origin + item.url
            })
            self.pageImgNo = 1
            self.urlList = json.data.data
            self.totalImg = self.urlList.length
            self.showImg = true
          } else {
            self.$message.warning(json.data.errorMessage)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 关闭详情弹框
    handleImgCancel () {
      this.showImg = false
    },

    // 点击文物图片的分页
    changeImgPage (val) {
      this.pageImgNo = val
    }
  }
}
</script>

<style>
.yht-backStage-jpww {
  padding-bottom: 40px;
  width: 100%;
  height: 100%;
}

.yht-backStage-jpww-content {
  position: relative;
  padding: 30px;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 4px 50px 8px rgba(0, 0, 0, 0.06);
}

.yht-backStage-jpww-content_btn {
  width: 98px;
  height: 36px;
  line-height: 36px;
  color: #666666;
  text-align: center;
  border-radius: 4px;
  background: #ffffff;
  border: 1px solid #666666;
}

.yht-backStage-jpww-content_btn:hover {
  color: #8b1d13;
  border-color: #8b1d13;
}

.yht-backStage-jpww-content_search {
  position: absolute;
  top: 20px;
  right: 30px;
}

.jpww-input {
  width: 360px;
  height: 38px;
  border-radius: 4px;
}

.jpww-input .el-input__inner,
.jpww-input .el-input.is-active .el-input__inner,
.jpww-input .el-input__inner:focus,
.jpww-input .el-input__inner:hover {
  border-color: #ccc;
}

.jpww-input > .el-input__inner {
  padding-right: 45px;
}

.yht-backStage-jpww-content_search_icon {
  position: absolute;
  top: 50%;
  right: 10px;
  margin-top: -15px;
  width: 30px;
  height: 31px;
  background: url("../images/search.png");
  background-size: 100% 100%;
}

.yht-backStage-jpww_table {
  width: 100%;
  height: calc(100% - 56px);
}

.yht-backStage-jpww_page {
  position: relative;
  margin-top: 10px;
  width: 100%;
  height: 50px;
}

.yht-backStage-jpww_page .el-pagination {
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translate(-50%, -50%);
}

.yht-backStage-jpww_table_status {
  position: relative;
  padding-left: 20px;
}

.yht-backStage-jpww_table_status::before {
  content: "";
  position: absolute;
  top: 5px;
  left: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.yht-backStage-jpww_table_status.online::before {
  background: #60a93f;
}

.yht-backStage-jpww_table_status.offline::before {
  background: #c7c7c7;
}

.yht-backStage-jpww_table_operate {
  display: flex;
}

.yht-backStage-jpww_table_view {
  margin-right: 28px;
  width: 18px;
  height: 14px;
  background: url("../images/view.png");
  background-size: 100% 100%;
}

.yht-backStage-jpww_table_line {
  width: 15px;
  height: 17px;
  background: url("../images/online.png");
  background-size: 100% 100%;
}

.yht-backStage-jpww_table_line.offline {
  background: url("../images/offline.png");
  background-size: 100% 100%;
}

.yht-backStage_dialog_imgBox {
  display: flex;
  justify-content: center;
}

.yht-backStage_dialog_img {
  width: 420px;
  height: 280px;
}

.yht-backStage-dialog_page {
  position: relative;
  margin-top: 18px;
  width: 100%;
  height: 50px;
}

.yht-backStage-dialog_page .el-pagination {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
